import { Lock, ShieldCheck } from "lucide-react";

export default function PrivacyDisclaimer({ compact = false }) {
  if (compact) {
    return (
      <div className="text-center text-xs text-[#8A8D8A] mt-6 max-w-md mx-auto leading-relaxed">
        <Lock className="inline h-3 w-3 mr-1 align-text-bottom"/>
        This portal exists only to help your advisor build your financial plan. Your data is encrypted, stays private, and is never shared, sold or leaked — only your assigned advisor can see it.
      </div>
    );
  }
  return (
    <div className="border-t border-[#E5E2DA] bg-white/60 backdrop-blur">
      <div className="max-w-5xl mx-auto px-6 md:px-12 py-8 flex flex-col sm:flex-row gap-4 items-start sm:items-center">
        <div className="flex-shrink-0 h-10 w-10 rounded-full bg-[#3A5C45]/10 flex items-center justify-center">
          <ShieldCheck className="h-5 w-5 text-[#1A3626]" strokeWidth={1.5}/>
        </div>
        <div className="text-sm text-[#5B5E5B] leading-relaxed">
          <span className="font-medium text-[#1C1D1C]">Your data stays private.</span> This portal exists only to help your advisor at Wealth Accelerator Hub build your financial plan. Your information is encrypted in transit and at rest, never shared with third parties, never sold, and never leaked — only your assigned advisor can access it.
        </div>
      </div>
    </div>
  );
}
